var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 10C29.5 5.85786 26.1421 2.5 22 2.5C17.8579 2.5 14.5 5.85786 14.5 10C14.5 14.1421 17.8579 17.5 22 17.5C26.1421 17.5 29.5 14.1421 29.5 10ZM22 5.5C24.4853 5.5 26.5 7.51472 26.5 10C26.5 12.4853 24.4853 14.5 22 14.5C19.5147 14.5 17.5 12.4853 17.5 10C17.5 7.51472 19.5147 5.5 22 5.5Z",
    fill: "#009BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 34C16.5 29.8579 13.1421 26.5 9 26.5C4.85786 26.5 1.5 29.8579 1.5 34C1.5 38.1421 4.85786 41.5 9 41.5C13.1421 41.5 16.5 38.1421 16.5 34ZM9 29.5C11.4853 29.5 13.5 31.5147 13.5 34C13.5 36.4853 11.4853 38.5 9 38.5C6.51472 38.5 4.5 36.4853 4.5 34C4.5 31.5147 6.51472 29.5 9 29.5Z",
    fill: "#009BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 26.5C39.1421 26.5 42.5 29.8579 42.5 34C42.5 38.1421 39.1421 41.5 35 41.5C30.8579 41.5 27.5 38.1421 27.5 34C27.5 29.8579 30.8579 26.5 35 26.5ZM39.5 34C39.5 31.5147 37.4853 29.5 35 29.5C32.5147 29.5 30.5 31.5147 30.5 34C30.5 36.4853 32.5147 38.5 35 38.5C37.4853 38.5 39.5 36.4853 39.5 34Z",
    fill: "#009BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4094 13.1246C13.0305 12.5764 13.0896 11.6285 12.5414 11.0074C11.9932 10.3863 11.0453 10.3272 10.4242 10.8754C6.79352 14.0798 4.5 18.773 4.5 24.0001C4.5 24.8285 5.17157 25.5001 6 25.5001C6.82843 25.5001 7.5 24.8285 7.5 24.0001C7.5 19.6695 9.39656 15.7837 12.4094 13.1246Z",
    fill: "#009BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5758 10.8754C32.9547 10.3272 32.0068 10.3863 31.4586 11.0074C30.9104 11.6285 30.9695 12.5764 31.5906 13.1246C34.6034 15.7837 36.5 19.6695 36.5 24.0001C36.5 24.8285 37.1716 25.5001 38 25.5001C38.8284 25.5001 39.5 24.8285 39.5 24.0001C39.5 18.773 37.2065 14.0798 33.5758 10.8754Z",
    fill: "#009BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3739 38.0433C17.5716 37.8368 16.7538 38.3198 16.5473 39.1221C16.3409 39.9244 16.8238 40.7421 17.6261 40.9486C19.0257 41.3089 20.4916 41.5001 22 41.5001C23.5084 41.5001 24.9743 41.3089 26.3739 40.9486C27.1762 40.7421 27.6591 39.9244 27.4527 39.1221C27.2462 38.3198 26.4284 37.8368 25.6261 38.0433C24.4687 38.3412 23.254 38.5001 22 38.5001C20.746 38.5001 19.5312 38.3412 18.3739 38.0433Z",
    fill: "#009BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCircle);
export default __webpack_public_path__ + "static/media/share_circle.58bf2045f8f32a35d526c7abfb051c4d.svg";
export { ForwardRef as ReactComponent };